import BaseAPI from "./base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class AuditAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "Audit";

  /**
   * ntnghia - 07/05/2021
   *  Lấy tài sản ngoài sanh sách theo id.
   */
  getAssetOutByAuditID(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-out-auditid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * ntnghia - 07/05/2021
   *  Lấy thành phần tham gia theo id.
   */
  getMemberByAuditID(payload) {
    let request = {
      url: [this.getAPIUrl(), "member-auditid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * @author vvkiet - 08.05.2021
   * Cập nhật trạng thái có muốn hiển thị màn hình bắt đầu kiểm kê
   */
  updateNotShowAgain(payload) {
    let request = {
      url: [this.getAPIUrl(), "not-show-again"].join("/"),
      data: payload,
    };

    return httpClient.putAsync(request);
  }

  /**
   * @override: Lấy dữ liệu danh sách
   * @author vvkiet - 08.05.2021
   */
  getList(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/list";

    // Nếu là danh sách kiểm kê
    if (payload.type == "audit") {
      url = this.getAPIUrl() + "/ListAuditByUser";
    }

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * @author vvkiet - 08.05.2021
   * Xóa kiểm kê
   */
  deleteAudit(item) {
    let request = {
      url: [this.getAPIUrl(), "delete-audit"].join("/"),
      data: item,
    };

    return httpClient.deleteAsync(request);
  }

  /**
   * Lấy dữ liệu detail màn hình ghi tăng tài sản
   * @param {*} payload
   * @returns repose
   * @author DVQUAN 12.5.2021
   */
  getAuditIncrementDetail(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-audit-increment-paging"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu detail màn hình ghi giảm tài sản
   * @param {*} payload
   * @returns repose
   * @author DVQUAN 13.5.2021
   */
  getAuditDecrementDetail(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-audit-decrement-paging"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * NTAnh2 - 12/05/2021
   *  Lấy danh sách tài sản chênh lệch theo id biên bản kiểm kê.
   */
  getAssetDiffByAuditID(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-diff-auditid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new AuditAPI();
